/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedButton from '.';
import ThreeDotsBlackLoader from '../LoadingDots/ThreeDotsBlack';
import { backNextLanguageContent } from './backNextLanguageContent';
import ApplicationContext from '../../context/ApplicationContext';

function NextButton(props) {
    const { disabled, handleClick, loader } = props;
    const { selectedLanguage } = useContext(ApplicationContext);
    return (
        <AnimatedButton disabled={disabled}
            handleClick={() => handleClick()}  id="next_button" className={`font-semibold fold-normal-text text-gray w-[200px] h-[40px] ${loader ? '' : 'pl-[41px]'} bg-[#F2F2F2] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
            {loader ? <ThreeDotsBlackLoader /> : backNextLanguageContent['next'][selectedLanguage]}
            {!loader && <img src="/images/next.svg" alt="next" className='ml-[1.5em] w-[1.7em] h-[1.7em]' />}
        </AnimatedButton>
    );
}

export default NextButton;